export default class SukuButtonRow extends HTMLElement {
  static get observedAttributes() {
    return ['type', 'active', 'selected', 'key', 'filter', 'relation']
  }

  constructor() {
    super()

    this.className = 'flex flex-wrap mb-8 hidden mobile:mb-5'

    this.addEventListener('filter', this.handleFilter.bind(this))
    window.addEventListener('active', this.handleActive.bind(this))
  }

  connectedCallback() {
    this.type = this.getAttribute('type')
    this.active = this.getAttribute('active') === 'true' ? true : false
    this.key = this.getAttribute('key')
    this.filter = this.getAttribute('filter')
    this.relation = this.getAttribute('relation')
    this.byline = this.getAttribute('byline')

    const container = document.createElement('div')
    container.setAttribute('data-title-container', '')
    container.className = 'w-full text-base mb-2.5 font-semibold'

    const title = document.createElement('p')
    title.className = 'font-base mb-0 mobile:text-sm'
    title.setAttribute('data-title', '')
    title.textContent = this.byline

    container.appendChild(title)

    this.container = container
    this.title = title

    this.appendChild(this.container)

    if (this.active) {
      this.classList.remove('hidden')
    }
  }

  handleFilter(evt) {
    const name = evt.detail.name
    const key = evt.detail.key

    const buttons = this.querySelectorAll('suku-button')

    switch (evt.detail.type) {
      case 'category' :
        break
      case 'size' :
        break
    }

    this.dispatchEvent(new CustomEvent('update', { bubbles: true, detail: { key: this.type, value: key } }))

    Array.from(buttons).forEach(button => {
      const active = button.getAttribute('name') === name

      button.setAttribute('active', active)
    })

    this.dispatchEvent(new CustomEvent('active', { bubbles: true, detail: { from: this.type, key: key, relation: this.relation, name: name } }))

    this.setAttribute('filter', name)
    this.setAttribute('key', key)
  }

  handleActive(evt) {
    if (evt.detail.relation !== this.type) {
      return
    }

    const buttons = this.querySelectorAll('suku-button')

    // filter buttons to show based available options and sizes
    const showButtons = []
    window.__SUKU_Options.map(option => {
      if (option.category === evt.detail.key) {
        option.product.variants.map(item => {
          if (!showButtons.includes(item.options[0]) && !showButtons.includes('Pillowcase Set')) {
            const button = evt.detail.key === 'pillowcases' ? 'Pillowcase Set' : item.options[0]
            
            showButtons.push(button)
          }
        })
      }
    })

    // update buttons
    Array.from(buttons).forEach(button => {
      const show = showButtons.findIndex(btn => btn === button.getAttribute('name')) > -1
      button.setAttribute('show', show)
      button.setAttribute('active', false)
    })

    if (this.categoryName) {
      this.categoryName.textContent = evt.detail.name.toLowerCase()
    }
    const active = evt.detail.relation === this.type

    this.setAttribute('active', active)
    
    this.setAttribute('filter', '') // reset filter
    this.setAttribute('key', '') // reset key
  }

  toggle() {
    if (this.active) {
      this.classList.remove('hidden')
    } else {
      this.classList.add('hidden')
    }
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'active' :
        this.active = value === 'true' ? true : false

        this.toggle()
      break
    }
  }
}

customElements.define('suku-button-row', SukuButtonRow)
